import {
  BgImage,
  BgImageFilter,
  BgImageLayer,
  BgImageWrapper,
  SvgWrapper,
} from "./style";
import { useEffect, useRef, useState } from "react";

export const Background = () => (
  <BgImageWrapper>
    <SvgWrapper
      width={window.innerWidth}
      height={window.innerHeight}
      viewBox={`0 0 ${window.innerWidth} ${window.innerHeight}`}
    >
      <filter id="filter" width="700%" height="700%">
        {/* <feGaussianBlur stdDeviation={600} in="SourceGraphic" /> */}
      </filter>
      <mask id="svgmask1">
        <rect
          // x={x}
          // y={y}
          width="200"
          height={window.innerHeight}
          rx="15"
          fill={"white"}
          filter="url(#filter)"
        />
      </mask>
      <image
        x={0}
        y={0}
        height={window.innerHeight}
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={
          window.WP_PATH +
          "/wp-content/uploads/2023/03/About-%E2%80%93-Wireframe-%E2%80%93-2.jpg"
        }
        // xlinkHref="https://comanage-dev.spindoxlabs.com/wp-content/uploads/2023/03/About-%E2%80%93-Wireframe-%E2%80%93-2.jpg"
        mask="url(#svgmask1)"
      ></image>
    </SvgWrapper>
    <BgImageLayer />
    <BgImageFilter />
    {/* <BgImageIllustration src={`http://localhost:3000/COMANAGE-graphic.png`} /> */}
    {/* <BgImage
      src={`https://comanage-dev.spindoxlabs.com/wp-content/uploads/2023/03/Web-1920-%E2%80%93-1-1.jpg`}
    /> */}
    <SvgWrapper
      width={window.innerWidth}
      height={window.innerHeight}
      viewBox={`0 0 ${window.innerWidth} ${window.innerHeight}`}
      style={{ zIndex: 1 }}
    >
      <image
        x={0}
        y={0}
        height={window.innerHeight}
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xlinkHref={
          window.WP_PATH +
          "/wp-content/uploads/2023/03/About-%E2%80%93-Wireframe-%E2%80%93-2.jpg"
        }
        // xlinkHref="https://comanage-dev.spindoxlabs.com/wp-content/uploads/2023/03/About-%E2%80%93-Wireframe-%E2%80%93-2.jpg"
      ></image>
    </SvgWrapper>
  </BgImageWrapper>
);
